/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { ISmallBannerData } from './small-banner.data';
import { ISmallBannerProps } from './small-banner.props.autogenerated';

export interface ISmallBannerViewProps
  extends ISmallBannerProps<ISmallBannerData> {
  smallBanner?: React.ReactNode;
}

/**
 *
 * SmallBanner component
 * @extends {React.PureComponent<ISmallBannerProps<ISmallBannerData>>}
 */
class SmallBanner extends React.PureComponent<
  ISmallBannerProps<ISmallBannerData>
> {
  public render(): JSX.Element | null {
    const { bannerImage, bannerAltText, bannerLink } = this.props.config;
    const bannerImageProps = {
      gridSettings: this.props.context.request.gridSettings || {},
      imageSettings: bannerImage && bannerImage.imageSettings,
    };
    const toysrusBannerImage = bannerImage && (
      <Msdyn365.Image
        className='img-responsive full-width'
        altText={bannerAltText}
        {...bannerImage}
        {...bannerImageProps}
        editProps={{
          key: this.props.config.bannerImage || {},
          requestContext: this.props.context.request,
        }}
      />
    );

    const smallBannerItem = (
      <div className='row show-in-mobile'>
        <div className='col-lg-12 col-md-12 col-sm-12'>
          <a href={bannerLink} className='banner-link'>
            {toysrusBannerImage}
          </a>
        </div>
      </div>
    );
    const SmallBannerProps = {
      ...this.props,
      smallBanner: smallBannerItem,
    };
    return this.props.renderView(SmallBannerProps);
  }
}

export default SmallBanner;
